// extracted by mini-css-extract-plugin
module.exports = {"alert":"iV","alertIcon":"iW","formContainer":"iX","formContainerInner":"iY","successIcon":"iZ","footer":"i0","footerItem":"i1"};